import { appLocalStorage } from '@/app/shared/commonURLs';
//var baseSupplyChainUrl = SupplyChainUrl;
// var SupplyChainODataUrl = commonURLs().SupplyChainODataUrl;

//let storage = new services();
let SupplyChainUrl = appLocalStorage.SupplyChainUrl;
let SupplyChainODataUrl = appLocalStorage.SupplyChainODataUrl;
let FinanceODataUrl = appLocalStorage.FinanceODataUrl;
let VisitManagementODataUrl = appLocalStorage.VisitManagementODataUrl;

export class uRls {
    constructor() {
        this.inventoryManagementServicesList = inventoryManagementURls();
        this.inventoryManagementOdataServiceList = inventoryManagementOdataServiceURls();
        this.visitManagementOdataServiceList = visitManagementOdataServiceURls();
    }
}

const inventoryManagementURl = new uRls();

export { inventoryManagementURl };


//////for non-odata services only
function inventoryManagementURls() {
    var services = {};

    //================ Product Category Services ======================
    services["InitializeAddProductCategory"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'ProductCategory/InitAddProductCategory',
    };
    services["getProductCategoryByClassificationId"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'ProductCategory/GetProductCategoryByClassificationId',
    };
    services["checkProductCategoryDuplication"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'ProductCategory/CheckDuplication',
    };
    services["addProductCategory"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'ProductCategory/AddProductCategory',
    };
    services["InitializeEditProductCategory"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'ProductCategory/InitEditProductCategory',
    };
    services["checkProductCategoryNotDeleted"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'ProductCategory/CheckProductNotDeleted',
    };
    services["editProductCategory"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'ProductCategory/EditProductCategory',
    };
    services["deleteProductCategory"] = {
        Method: 'DELETE',
        URL: SupplyChainUrl + 'ProductCategory/DeleteProductCategory',
    };
    //================ UOM Category Services  ======================
    services["getProductUOMByUOMCategoryID"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCUOMCategory/GetProductUOMByUOMCategoryID',
    };
    services["checkUOMCategoryNameDuplication"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCUOMCategory/CheckUOMCategoryNameDuplication',
    };
    services["getReferenceTypesDDL"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCUOMCategory/GetReferenceTypesDDL',
    };
    services["addUOMCategory"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCUOMCategory/AddUOMCategory',
    };
    services["checkUOMNameDuplication"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCUOMCategory/CheckUOMNameDuplication',
    };
    services["updateUOMCategory"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCUOMCategory/EditUOMCategory',
    };
    services["checkUOMCategoryAssignedToProducts"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCUOMCategory/CheckUOMCategoryAssignedToProducts',
    };
    services["deleteUOMCategory"] = {
        Method: 'Delete',
        URL: SupplyChainUrl + 'SCUOMCategory/DeleteUOMCategory',
    };
    //************** Warehouse Services ***************//
    services["InitializeAddWarehouse"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCWarehouse/Add',
    }

    services["getProductCategoriesByClassificationIds"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCWarehouse/GetProductCategoriesByClassificationIDs',
    }
    services["checkDuplication"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCWarehouse/CheckNameDuplication',
    },

        services["addNewWarehouse"] = {
            Method: 'POST',
            URL: SupplyChainUrl + 'SCWarehouse/AddNewWarehouse',
        },

        services["checkWarehouseNotDeleted"] = {
            Method: 'Get',
            URL: SupplyChainUrl + 'SCWarehouse/CheckWarehouseNotDeleted',
        },

        services["InitializeEditWarehouse"] = {
            Method: 'Get',
            URL: SupplyChainUrl + 'SCWarehouse/Edit',
        },

        services["GetActiveAndNotDeletedWarehousesAsDropDown"] = {
            Method: 'Get',
            URL: SupplyChainUrl + 'SCWarehouse/GetActiveAndNotDeletedWarehousesAsDropDown',
        },

        services["deleteWarehouse"] = {
            Method: 'DELETE',
            URL: SupplyChainUrl + 'SCWarehouse/Delete',
        },

        services["editWarehouse"] = {
            Method: 'POST',
            URL: SupplyChainUrl + 'SCWarehouse/EditWarehouse',
        },

        services["checkIsEmployeeAssignedToWarehouse"] = {
            Method: 'GET',
            URL: SupplyChainUrl + 'SCWarehouse/CheckIsEmployeeAssignedToWarehouse',
        },
        services["checkLocationsBalance"] = {
            Method: 'Get',
        URL: SupplyChainUrl + 'SCWarehouse/CheckLocationsBalance',
        },


        //************* Warehouse Category Services ********//
        services["deleteWarehouseCategory"] = {
            Method: 'DELETE',
            URL: SupplyChainUrl + 'WarehouseCategory/Delete'
        };
    services["checkWarehouseCategoryNameDuplication"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'WarehouseCategory/CheckDuplication'
    };
    services["checkWarehouseCategoryPrefixDuplication"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'WarehouseCategory/CheckDuplication' 
    };
    services["getWarehouseCategoryDDL"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'WarehouseCategory/GetWarehouseCategories'
    };
    services["addWarehouseCategory"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'WarehouseCategory/AddWarehouseCategory'
    };
    services["updateWarehouseCategory"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'WarehouseCategory/UpdateWarehouseCategory'
    };
    //************* Product Services ********//
    services["InitializeAddProduct"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SupplyChainProduct/InitializeAddProduct',
    };
    services["getProductUOMByUOMCategory"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SupplyChainProduct/GetProductUOMByUOMCategoryID',
    }

    services["addNewProduct"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SupplyChainProduct/AddNewProduct'
    }

    services["editProduct"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SupplyChainProduct/EditProduct'
    }

    services["checkProductNameDuplication"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SupplyChainProduct/CheckNameDuplication',
    }
    services["checkProductNotDeleted"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SupplyChainProduct/CheckProductNotDeleted',
    };
    services["deleteProduct"] = {
        Method: 'DELETE',
        URL: SupplyChainUrl + 'SupplyChainProduct/Delete',
    };
    services["InitializeEditProduct"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SupplyChainProduct/InitializeEditProduct',
    };
    //*************** Vendor Group Services **************//
    services["InitializeAddVendorGroup"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCVendorGroup/InitializeAddVendorGroup',
    };
    services["InitializeUpdateVendorGroup"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCVendorGroup/InitializeUpdateVendorGroup',
    };
    services["CheckDuplication"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCVendorGroup/CheckDuplication',
    };
    services["AddVendorGroup"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCVendorGroup/AddVendorGroup',
    };
    services["UpdateVendorGroup"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCVendorGroup/UpdateVendorGroup',
    };
    services["IsVendorGroupDeleted"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCVendorGroup/IsVendorGroupDeleted',
    };
    services["deleteVendorGroup"] = {
        Method: 'DELETE',
        URL: SupplyChainUrl + 'SCVendorGroup/DeleteVendorGroup',
    };
    //*************** Vendor Services **************//

    services["InitializeAddVendor"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCVendor/InitializeAddVendor',
    };
    services["checkNameDuplication"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCVendor/CheckNameDuplication',
    };

    services["checktaxAndvatIDDuplication"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCVendor/CheckTaxAndVATIDDuplication',
    };
    services["checkGLNDuplication"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCVendor/CheckGLNDuplication',
    };
    services["checkGLNHasTransaction"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCVendor/CheckGLNUsedInTransaction',
    };
    services["addNewVendor"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCVendor/AddNewVendor',
    };

    services["InitializeEditVendor"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCVendor/InitializeEditVendor',
    };

    services["GetVATNumberConfig"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCVendor/GetVATNumberConfig',
    };
    services["checkVendorNotDeleted"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCVendor/CheckVendorNotDeleted',
    };

    services["editVendor"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCVendor/EditVendor',
    };

    services["deleteVendor"] = {
        Method: 'DELETE',
        URL: SupplyChainUrl + 'SCVendor/Delete',
    },
        //*************** Purchase Order Services **************//
        services["GetPurchaseOrderStatus"] = {
            Method: 'Get',
        URL: SupplyChainUrl + 'PurchaseOrder/GetPurchaseOrderStatus',
        };
        services["InitAddPurchaseOrder"] = {
            Method: 'Get',
            URL: SupplyChainUrl + 'PurchaseOrder/InitAddPurchaseOrder',
        };
    services["GetVendorsTreeView"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'PurchaseOrder/GetVendorsTreeView',
    };
    services["GetLastPurchaseOrderUnitPriceUOM"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'PurchaseOrder/GetLastPurchaseOrderUnitPriceUOM',
    };
    services["AddPurchaseOrder"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'PurchaseOrder/AddPurchaseOrder',
    };
    services["UpdatePurchaseOrder"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'PurchaseOrder/UpdatePurchaseOrder',
    };

    services["getCityByCountryId"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCVendor/GetCityByCountryId',
    };
    services["deletePurchaseOrder"] = {
        Method: 'DELETE',
        URL: SupplyChainUrl + 'PurchaseOrder/DeletePurchaseOrder'
    };
    services["checkPurchaseOrderNotDelete"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'PurchaseOrder/CheckPurchaseOrderNotDelete',
    };
    services["initEditPurchaseOrder"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'PurchaseOrder/InitEditPurchaseOrder',
    };
    services["initViewPurchaseOrder"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'PurchaseOrder/InitViewPurchaseOrder',
    };
    services["dismissPurchaseOrder"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'PurchaseOrder/DismissPurchaseOrder'
    };
    services["initValidatePurchaseOrder"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'PurchaseOrder/InitValidatePurchaseOrder',
    };
    services["ValidatePurchaseOrder"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'PurchaseOrder/ValidatePurchaseOrder',
    };
    //*************** Internal Request Services **************//
    services["InitializeCreateInternalRequest"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCInternalRequest/InitializeCreateInternalRequest'
    };
    services["GetWarehousesRoutes"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCInternalRequest/GetWarehouses_RouteshaveReceiveIRFunction',
    };
    services["AddInternalRequest"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCInternalRequest/AddNewInternalRequest',
    };
    services["getInternalRequestStatusDDL"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCInternalRequest/GetInternalRequsetStatusDDL',
    }
    services["deleteInternalRequest"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCInternalRequest/DeleteInternalRequest',
    }
    services["IsInternalRequestDeleted"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCInternalRequest/IsInternalRequestDeleted',
    };
    services["InitializeEditInternalRequest"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCInternalRequest/InitializeEditInternalRequest'
    };
    services["EditInternalRequest"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCInternalRequest/EditInternalRequest'
    };
    services["ViewInternalRequest"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCInternalRequest/ViewInternalRequest'
    };

    //================ purchase requisition  Services  ======================
    services["GetPurchaseRequisitionStatus"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCPurchaseRequisition/GetPurchaseRequisitionStatus',
    }
    services["deletePurchaserequisition"] = {
        Method: 'DELETE',
        URL: SupplyChainUrl + 'SCPurchaseRequisition/DeletePurchaseRequisition'
    }
    services["initializeAddPurchaseReq"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCPurchaseRequisition/InitializeAddPurchaseReq'
    }
    services["checkPurchaseRequisitionNotDelete"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCPurchaseRequisition/checkPurchaseRequisitionNotDelete'
    };
    services["addPurchaseReq"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCPurchaseRequisition/AddNewPurchaseRequisition',
    };
    services["getWarehouseDrafts"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCPurchaseRequisition/GetWarehouseDraftsById',
    };
    services["initializeEditPurchaseRequisition"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCPurchaseRequisition/InitializeEditPurchaseRequisition'
    }
    services["editPurchaseRequisition"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCPurchaseRequisition/EditPurchaseRequisition'
    }

    //================ goods Receipt  Services  ======================
    services["initializeAddGoodsReceipt"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCGoodsReceipt/InitializeAddGoodsReceipt',
    };
    services["getPurchaseOrdersDDL"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCGoodsReceipt/GetPurchaseOrdersDDL',
    };
    services["getPurchaseOrderProductsDetails"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCGoodsReceipt/GetPurchaseOrderProductsDetails',
    };
    services["addGoodsReceipt"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCGoodsReceipt/AddGoodsReceipt',
    };
    services["updateVendorInvoiceNumber"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCGoodsReceipt/updateVendorInvoiceNumber',
    };
    services["isSerailNumExists"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCGoodsReceipt/IsSerailNumExists',
    };
    services["ViewGoodsReceipt"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCGoodsReceipt/ViewGoodsReceipt',
    };
    services["getGoodsReceiptStatusDDL"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCGoodsReceipt/GetGoodsReceiptStatusDDL',
    };
    services["getGoodsReceiptRSDStatusDDL"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCGoodsReceipt/GetGoodsReceiptRSDStatusDDL',
    };
    services["initializeEditGoodsReceipt"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCGoodsReceipt/InitializeEditGoodsReceipt',
    };
    services["updateGoodsReceipt"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCGoodsReceipt/UpdateGoodsReceipt',
    };
    services["addAndValidateGoodsReceipt"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCGoodsReceipt/AddAndValidateGoodsReceipt',
    };
    services["saveAndValidateGoodsReceipt"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCGoodsReceipt/SaveAndValidateGoodsReceipt',
    };
    services["deleteGoodsReceipt"] = {
        Method: 'DELETE',
        URL: SupplyChainUrl + 'SCGoodsReceipt/DeleteGoodsReceipt',
    };
    services["GetProductsPriceFromBillingGoodsReceipt"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCGoodsReceipt/GetProductsPriceFromBilling',
    };

    services["GetProductDetailsByVendorBarcode"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCGoodsReceipt/GetProductDetailsByVendorBarcode',
    };
        //================ transfer out  Services  ======================

    services["InitializeAddTransferOut"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCTransferOut/InitializeAddTransferOut'
    };
    services["GetUnCompletedStockCountsForWarehouse"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCTransferOut/GetUnCompletedStockCountsForWarehouse'
    };
    services["GetWarehousesRouteshaveTransferIn"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCTransferOut/GetWarehouses_RouteshasTransferInFunction',
    };
    services["GetProductDetails"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCTransferOut/GetProductDetails',
    };
    services["AddTransferOut"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCTransferOut/AddTransferOut',
    };
    services["getTransferOutStatusDDL"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCTransferOut/GetTransferOutStatusDDL',
    };
    services["ViewTransferOut"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCTransferOut/ViewTransferOut',
    };
    services["getProductDetailsByBarcode"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCTransferOut/GetProductDetailsByBarcode',
    };
    services["CheckTransferOutStatusAndPostedJE"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCTransferOut/CheckTransferOutStatusAndPostedJE',
    };
    services["InitializeEditTransferOut"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCTransferOut/InitializeEditTransferOut',
    };
    services["UpdateTransferOut"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCTransferOut/UpdateTransferOut',
    };
    services["deleteTransferOut"] = {
        Method: 'DELETE',
        URL: SupplyChainUrl + 'SCTransferOut/DeleteTransferOut',
    };
     //================ Transfer In Services ==============================
    services["getTransferInStatusDDL"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCTransferIn/GetTransferInStatusDDL',
    };
    services["getTransferInDetail"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCTransferIn/GetTransferInDetails',
    };
    services["receiveTransferIn"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCTransferIn/ReceiveTransferIn',
    };
    services["rejectAllTransferIn"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCTransferIn/RejectAllTransferIn',
    };

    //================ return transaction Services ==============================
    services["getReturnTransactionStatusDDL"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCReturnTransaction/GetReturnTransactionStatusDDL',
    };
    services["initializeAddReturnToVendor"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCReturnToVendor/InitReturnToVendor'
    };
    services["GetReturnVendorsTreeView"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCReturnToVendor/GetVendorsTreeView',
    };
    services["GetGoodsReceiptDDL"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCReturnToVendor/GetGoodsReceiptDDL',
    };
    services["GetReturnToVendorDetails"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCReturnToVendor/GetReturnToVendorDetails',
    };
    services["GetReturnProductDetails"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCReturnToVendor/GetProductDetails',
    };
    services["AddReturnToVendor"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCReturnToVendor/SaveReturnToVendor',
    };
    services["getGoodsReceiptProduct"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCReturnToVendor/GetGoodsReceiptProduct',
    };

    services["getReturnTransactionDetails"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCReturnTransaction/GetReturnTransferDetails',
    };
    services["receiveReturnTransaction"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCReturnTransaction/ReceiveReturn',
    };
    services["getReturnToVendor"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCReturnToVendor/getReturnToVendor',
    };
    services["initializeEditReturnToVendor"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCReturnToVendor/InitializeEditReturnToVendor'
    };
    services["EditReturnToVendor"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCReturnToVendor/EditReturnToVendor',
    };
    services["CheckBilledReturnVendorandPostedJE"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCReturnToVendor/CheckBilledReturnVendorandPostedJE',
    };
    services["CheckBilledReturnVendorandDeletableJE"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCReturnToVendor/CheckBilledReturnVendorandDeletable',
    };
    services["deleteReturnVendor"] = {
        Method: 'DELETE',
        URL: SupplyChainUrl + 'SCReturnToVendor/DeleteReturnToVendor',
    };
    //================ Stock Count Services ==============================
    services["getStockCountStatusDDL"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCStockCount/GetStockCountStatusDDL',
    };
    services["initStockCount"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCStockCount/InitStockCount',
    };
    services["getProductCategoriesByWarehouse"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCStockCount/GetProductCategoriesByWarehouse',
    };
    services["saveStockCount"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCStockCount/SaveStockCount',
    };
    services["uploadStockCountSheet"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCStockCount/ValidateAndUploadStockCountSheet',
    };
    services["checkLocationLinkedToStockCount"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCStockCount/CheckLocationLinkedToStockCount',
    };
    services["downloadStockCount"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCStockCount/DownloadStockCount',
    };
    services["deleteStockCount"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCStockCount/DeleteStockCount',
    };
    services["getWarehouseUnFreezeResultOfStockCount"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCStockCount/GetWarehouseUnFreezeResultOfStockCount',
    };
     //================ Receive Internal Request Services ==============================
    services["initReceiveInternalRequest"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCReceiveInternalRequest/GetReceiveInternalRequestModelDetails',
    };
    services["GetReceiveInternalRequestProductDetails"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCReceiveInternalRequest/GetProductDetails',
    };
    services["sendReceiveInternalRequest"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCReceiveInternalRequest/SaveReceiveInternalRequest',
    };
    services["rejectAllReceiveInternalRequest"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCReceiveInternalRequest/RejectAllReceiveInternalRequest',
    };
    services["checkReceiveIRNotDeleted"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCReceiveInternalRequest/CheckReceiveIRNotDeleted',
    };
    services["getProductDetailsByBarcodeInReceiveIR"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCReceiveInternalRequest/GetProductDetailsByBarcode',
    };
  //================= Manufacturing Order Services ======================================

    services["InitializeAddManufacturingOrder"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCManufacturingOrder/InitializeAddManufacturingOrder'
    };
    services["getProductRawMaterials"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCManufacturingOrder/GetProductRawMaterials',
    };
    services["addManufacturingOrder"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCManufacturingOrder/AddManufacturingOrder',
    };
    services["viewManufacturingOrder"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCManufacturingOrder/ViewManufacturingOrder'
    };
    services["FillLocationByProductAndWarehouse"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCManufacturingOrder/FillLocationByProductAndWarehouse'
    };
    //================= Product Limits Service ======================================
    services["InitializeProductLimits"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCProductLimits/InitializeProductLimits'
    };

    services["GetProductCategoriesByWarehouse"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCProductLimits/GetProductCategoriesByWarehouse'
    };

    services["ExportProductLimitDetails"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCProductLimits/ExportProductLimitDetails'
    };
    services["UploadProductLimitSheet"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCProductLimits/UploadProductLimitSheet'
    };
    //================= Items Tracking Service ======================================
    services["initializeItemsTracking"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCItemsTracking/InitializeItemsTracking'
    };
    services["searchItemsTracking"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCItemsTracking/SearchItemsTracking'
    };
    services["isSerailNumDupplicated"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCItemsTracking/IsSerialNumExists'
    };
    services["AddItemsTracking"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCItemsTracking/AddItemsTracking'
    };
    services["GetProductsPriceFromBillingItemsTracking"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCItemsTracking/GetProductsPriceFromBilling',
    };
     //=============================Warehouse product barcode=================================================

    services["GetWarehousesReoprt"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCWarehouseProductsBarcodes/GetWarehouses'
    };

    services["GetProductsDetailsByWarehouseID"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCWarehouseProductsBarcodes/GetProductsDetailsByWarehouseID'
    };

    //=============================Bulk migration Data=================================================
    services["initBulkMigration"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCBulkDataMigration/InitializeBulkDataMigration'
    };

    services["excelTemplatesTypes"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCBulkDataMigration/ExcelTemplatesTypes'
    };

    services["saveBulkMigration"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCBulkDataMigration/SaveBulkMigration'
    };

    services["uploadBulkMigrationSheet"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCBulkDataMigration/UploadBulkMigrationSheet'
    };
    //============== Product Classification Assignment
    services["InitProductClassificationEmployee"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCProductClassificationEmployee/InitProductClassificationEmployee'
    }
    services["GetProductClassificationEmployees"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCProductClassificationEmployee/GetProductClassificationEmployees'
    }
    services["SaveProductClassificationEmployee"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCProductClassificationEmployee/SaveProductClassificationEmployee'
    };

    //============== Stock Count Browser

    services["InitializeAddStockCount"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCStockCountBrowser/InitializeAddStockCount'
    };
   
    services["GetProductDetailsForStockCount"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCStockCountBrowser/GetProductDetails',
    };
    services["AddStockCount"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCStockCountBrowser/AddStockCount',
    };

    services["UpdateStockCount"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCStockCountBrowser/UpdateStockCount',
    };

    services["getProductDetailsByBarcodeForStockCount"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCStockCountBrowser/GetProductDetailsByBarcode',
    };

    services["AddAndValidateStockCount"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCStockCountBrowser/AddAndValidateStockCount',
    };

    services["GetStockCountById"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCStockCountBrowser/GetStockCountById',
    };
    services["DeleteStockCountProduct"] = {
        Method: 'DELETE',
        URL: SupplyChainUrl + 'SCStockCountBrowser/DeleteStockCountProduct',
    };
    //============== Bill Of materials ==========================//
    services["getAllProducedProducts"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'ProductRawMaterials/GetProducedProducts'
    };
    services["getRawMaterials"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'ProductRawMaterials/GetRawMaterials/?producedProductID='
    };

    services["addOrEditRawMaterials"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'ProductRawMaterials/AddOrEditRawMaterials'
    };
    services["getProducedProduct"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'ProductRawMaterials/GetProducedProduct?producedProductID='
    };
    //============== WarehouseLocations ==========================//
    services["initWarehouseLocation"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCWarehouseLocation/InitWarehouseLocation'
    };
    services["GetWarehouseLocationsAsDropDownList"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCWarehouseLocation/GetWarehouseLocationsAsDropDownList'
    };

    services["AddNewWarhouseLocations"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCWarehouseLocation/AddNewWarhouseLocations'
    };

    services["warehouseLocationsForGenerateCodeAndNames"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCWarehouseLocation/GenerateCodeAndNames'
    };

    services["isWarehouseLocationArNameUniquePerWarehouse"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCWarehouseLocation/IsWarehouseLocationArNameUniquePerWarehouse'
    };

    services["isWarehouseLocationEnNameUniquePerWarehouse"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCWarehouseLocation/IsWarehouseLocationEnNameUniquePerWarehouse'
    };

    services["isWarehouseHasActiveAndNotDeletedLocations"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCWarehouseLocation/IsWarehouseHasActiveAndNotDeletedLocations'
    };

 
    services["initWarehouseLocationEditMode"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCWarehouseLocation/InitWarehouseLocationEditMode'
    };

    services["IsWarehouseLocationCanBeEdit"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCWarehouseLocation/IsWarehouseLocationCanBeEdit'
    };
    services["checkWarehouseLocationDuplication"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCWarehouseLocation/CheckNameDuplication',
    },
     services["UpdateNewWarhouseLocations"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCWarehouseLocation/UpdateWarhouseLocations'
    };
    //================ receiveDonation ==============================
    services["viewDonationnTransaction"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCBloodBankIntegration/ViewReceiveDonationTransaction'
    };

    //============== WarehouseStructure ==========================//
    services["GetWarehouseStructuresOfWarehouseAsSubLevelsDropDowns"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCWarehouseStructure/GetWarehouseStructuresOfWarehouseAsSubLevelsDropDowns'
    };

    //====================== InternalTransfer" ===============================
    services["InitializeCreateInternalTransfer"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCInternalTransfer/InitializeCreateInternalTransfer'
    };


    services["GetWarehouseLocationsForInternalTransfer"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCInternalTransfer/GetWarehouseLocations'
    };

    services["getProductDetailsByBarcodeForInternalTransfer"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCInternalTransfer/GetProductDetailsByBarcode',
    };
    services["GetProductDetailsForLoction"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCInternalTransfer/GetProductDetails',
    };
    services["AddInternalTransfer"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCInternalTransfer/AddInternalTransfer',
    };
    services["GetUnCompletedStockCountsForInternalTransfer"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCInternalTransfer/GetUnCompletedStockCountsForWarehouse'
    };
    services["GetUnCompletedStockCountsForWarehouseLocation"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCInternalTransfer/GetUnCompletedStockCountsForWarehouseLocation'
    };

    services["getRSDNotificationDDL"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCRSDNotification/GetRSDNotificationStatusDDL',
    }
    services["AddRSDNotification"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCRSDNotification/AddRSDNotification',
    }
    services["GetRSDTransactionsErrors"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCRSDNotification/GetRSDTransactionsErrors',
    }

    services["GetAllNphiesCategories"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCNPHIESIntegration/GetAllNphiesCategories'
    };

    services["GetNphiesCodesOfNphiesCategory"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'SCNPHIESIntegration/GetNphiesCodesOfNphiesCategory'
    };
    
    return services
}





function inventoryManagementOdataServiceURls() {
    var services = {};
    //************* Product Category Service ======================
    services["getActiveProductCategory"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'ProductCategoryOData?',
    },
        //************* Product Service ======================
        services["getProductList"] = {
            Method: 'Get',
            URL: SupplyChainODataUrl + 'SupplyChainProductOData?',
        }
    services["autocompleteRowMaterialsProducts"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'SCProducedProductOData?',
    };
    //================ Warehouse Services  ======================
    services["getWarehouseCategories"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'WarehouseCategoryOData?',
    }

    services["getWarehouses"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'WarehouseOData?',
    }

    services["getWarehouseLocations"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'WarehouseLocationOData?',
    }
    //================ UOM  Services  ======================
    services["getUOMCategory"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'UOMCategoryOData?',
    }
    services["getProductUOM"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'ProductUOMOData?',
    }
    //================ Vendor Group  Services  ======================
    services["getVendorGroup"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'SCVendorGroupOData?',
    }
    //================ Warehouse product  Services  ======================
    services["getWarehouseProduct"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'WarehouseProductOData',
    }
    //================ Vendor  Services  ======================
    services["getVendors"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'SCVendorOData?',
    }
    //================ purchase order  Services  ======================
    services["getPurchaseOrder"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'PurchaseOrderOData?',
    }
    //================ purchase requisition  Services  ======================
    services["getPurchaseRequisition"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'SCPurchaseRequisitionOData?',
    }
    //================ Internal request  Services  ======================
    services["getInternalRequests"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'SCInternalRequestOData?',
    }
    //================ Goods receipt  Services  ======================
    services["getGoodsReceipts"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'SCGoodsReceiptOData?',
    }
    //================ Taxes Services ==============================

    services["getTaxesList"] = {
        Method: 'Get',
        URL: FinanceODataUrl + 'TaxesRetrievalOData?'
    } 
    //================ Transfer Out Services ==============================
    services["transferOutLists"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'SCTransferOutOData?',
    }
        //================ CostCenter Services ==============================

    services["getCostCenterList"] = {
        Method: 'Get',
        URL: FinanceODataUrl + 'CostCenterOData?'
    } 
    //================ Transfer In Services ==============================
    services["transferInList"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'SCTransferInOData?',
    }
    //================ return transaction Services ==============================
    services["returnTransactionList"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'SCReturnTransactionOData?',
    }
    //================ Return To Vendor  Services  ======================
    services["returnToVendorList"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'SCReturnToVendorOData?',
    }
    //================= Stock Count Services ======================================
    services["stockCountList"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'SCStockCountOData?',
    }
    //================= Receive Internal Request Services ======================================
    services["getReceiveInternalRequestList"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'SCReceiveInternalRequestOData?',
    }
    //================= Manufacturing Order Services ======================================
    services["getManufacturingOrderList"] = {
        Method: 'POST',
        URL: SupplyChainODataUrl + 'SCManufacturingOrderOData?',
    }

    //================ Vendor auto complete  Services  ======================
    services["getVendorsAutoComplete"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'SCVendorAutoCompleteOData',
    }
    //============== Items tracking
    services["getItemsTracking"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'SCItemsTrackingOData',
    }
    services["getItemsTrackingDetails"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'SCItemsTrackingDetailsOData',
    }
    //================ receiveDonation ==============================
    services["receiveDonationList"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'SCBloodBankIntegrationOData?',
    }

    //------------------------------------------------------------
    services["getInternalTransfers"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'InternalTransferOData?',
    }
    //================ Product Warehouse Location auto complete  Services  ======================
    services["getProductWarehouseLocationAutoComplete"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'LocationProductOData',
    }

    services["getAllProductByLocationODataUrl"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'WarehouseLocationProductOData?',
    }

    services["getProductDetailByLocationODataUrl"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'WarehouseLocationProductDetailOData?',
    }
    services["getProductDetailByLocationODataUrl"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'WarehouseLocationProductDetailOData?',
    }

    //==================== RSD Notification List Services ======================
    services["getRSDNotificationODataUrl"] = {
        Method: 'Get',
        URL: SupplyChainODataUrl + 'SCRSDNotificationOData?',
    }

 
    return services
}

function visitManagementOdataServiceURls() {
    var services = {};
    services["getEmployees"] = {
        Method: 'Get',
        URL: VisitManagementODataUrl + 'AddCashPointOData?',
    }
    return services
}